module.exports = __webpack_public_path__ + "img/s5_stepimg01@2x.ef06d2dc.png";